<template>
  <div>
    <h2>💨アプリケーション💨</h2>
    <p>Windowsで動くアプリケーションです。</p>
    <b-container>
      <b-row>
        <!-- <b-col>
          <a
            href="https://px.a8.net/svt/ejp?a8mat=35JOPC+C0U5KI+1WP2+631SX"
            target="_blank"
            rel="nofollow"
          >
            <img
              border="0"
              width="100"
              height="100"
              alt
              src="https://www26.a8.net/svt/bgt?aid=190715088727&wid=001&eno=01&mid=s00000008903001022000&mc=1"
            />
          </a>
          <img
            border="0"
            width="1"
            height="1"
            src="https://www11.a8.net/0.gif?a8mat=35JOPC+C0U5KI+1WP2+631SX"
            alt
          />
        </b-col> -->

        <b-col v-for="app in apps" v-bind:key="`third-${app.name}`">
          <AppComponent :app="app" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AppComponent from "@/components/AppComponent";
export default {
  name: "AppsComponent",
  props: ["apps"],
  components: {
    AppComponent
  },
  data() {
    return {
      a: 1
    };
  },
  beforeCreate() {
    // At this time, |this.apps| is not defined
    // console.log(this.apps)
    // console.log("GitApp:beforeCreate")
  },
  created() {
    // console.log(this.apps)
    // console.log("GitApp:created")
  },
  mounted() {
    // console.log(this.apps)
  }
};
</script>

<style scoped>
h1 {
  text-align: center;
}
h3 {
  margin: 0%;
  padding: 0%;
  border: 0px;
  /* background-color: blue; */
}

div.appdesc {
  background-color: beige;
}
</style>
